<template>
  <div class="tw-flex tw-min-h-screen tw-flex-col">
    <NavigationTopBar />

    <div
      class="tw-container tw-mx-auto tw-mb-6 tw-mt-6 tw-flex tw-flex-grow tw-gap-6 tw-px-4 md:tw-mt-16"
      style="max-width: 1400px"
      data-margin-top="70"
    >
      <!-- Auth-only sidebar. Rendered client-only because SSR routes (e.g. public
           trip pages) render anonymously on the server, while the client restores
           the session before first paint — a bare `v-if` would hydration-mismatch. -->
      <ClientOnly>
        <div
          v-if="session_token"
          class="nav-bar-wrapper tw-sticky tw-hidden tw-h-fit tw-w-56 tw-flex-shrink-0 tw-flex-col tw-gap-6 md:tw-flex"
          style="top: calc(var(--top-bar-height, 0px) + 48px)"
        >
          <nav id="nav-bar" class="card tw-relative tw-pb-2 tw-pt-4">
            <div class="-tw-mt-10 tw-flex tw-flex-col tw-pb-2 tw-text-center">
              <div class="tw-mb-2">
                <router-link
                  :to="`/user/${id}/timeline`"
                  class="tw-relative tw-inline-flex tw-rounded-full"
                >
                  <userpic-item class="tw-h-14 tw-w-14 tw-border-2 tw-border-white" />

                  <UserTypeItem
                    class="tw-absolute -tw-right-2 -tw-top-2 tw-h-7 tw-w-7"
                    :account-type="user?.account_type"
                  />
                </router-link>
              </div>

              <h2 class="tw-mb-1 tw-text-lg tw-font-semibold tw-leading-none tw-text-black/80">
                <template v-if="user"> {{ user.firstname }} {{ user.lastname }} </template>

                <template v-else> - </template>
              </h2>

              <div class="tw-leading-none tw-text-black/90">
                <userbadge-item />
              </div>
            </div>

            <hr class="tw-my-2 tw-border-b-0 tw-border-t tw-border-black/5" />

            <div v-if="session_token" id="route-list" class="tw-px-4 tw-py-2">
              <NavigationMainMenu />
            </div>
          </nav>

          <user-stats v-if="user" :user="user" />
        </div>
      </ClientOnly>

      <div id="content" class="tw-w-full tw-flex-grow tw-overflow-hidden">
        <slot />
      </div>
    </div>

    <NavigationFooterBar />

    <NuxtLoadingIndicator />
  </div>
</template>

<script setup lang="ts">
const authStore = useAuthStore()

const session_token = computed(() => {
  return authStore.session_data.token
})

const id = computed(() => {
  return authStore.currentUser?.id
})

const user = computed(() => {
  return authStore.currentUser
})
</script>

<style scoped>
#route-list a {
  @apply tw-flex tw-items-center;
}

#route-list a .icon {
  @apply tw-mr-2 tw-flex tw-w-6 tw-items-center tw-justify-center;
}
</style>
